<mat-dialog-content color="primary">{{data.submitQuestion}}</mat-dialog-content>

<mat-dialog-actions>
	<button mat-raised-button [mat-dialog-close]="true" color="primary">{{data.submit}}</button>
	<button mat-raised-button [mat-dialog-close]="false" color="warn">{{data.abort}}</button>
</mat-dialog-actions>
